import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRollerConveyor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 160,
	height: 20,
	viewBox: "0 0 160.0 20.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 10,
			width: 160,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 20,
			cy: 10,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 10,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 80,
			cy: 10,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 110,
			cy: 10,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 140,
			cy: 10,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 10,
			width: 160,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgRollerConveyor;
